import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {VoceProgetto} from "../../Models/VoceProgetto";
import {ApiRestService} from "../../_services/api-rest.service";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {Destinazione} from "../../Models/destinazione";
import { IDropdownSettings } from 'src/LibrerieCustom/MultiselectDropdown';
import {ToastrService} from "ngx-toastr";


@Component({
  selector: 'app-destinazioni-move',
  templateUrl: './destinazioni-move.component.html',
  styleUrls: ['./destinazioni-move.component.css']
})
export class DestinazioniMoveComponent implements OnInit {
  @Input() item: VoceProgetto;
  @Input() idDestinazione: number;
  @Output() Refresh = new EventEmitter();
  Other: Destinazione[] = [];
  DropdownSettings: IDropdownSettings = {
    singleSelection: true,
    closeDropDownOnSelection: true,
    singleOutput:false,
    idField: 'id',
    textField: 'label',
    searchPlaceholderText: "inserire almeno 3 caratteri",
    allowSearchFilter: false,
    allowRemoteDataSearch: false,
  };
  SelectedOther: Destinazione[] = [];
  send: { voce?: number, quantita?: number, destinazione?: number } = {quantita: 0};
  constructor(
    private apiRestService: ApiRestService,
    private activeModal: NgbActiveModal,
    private toast: ToastrService,
  ) { }

  ngOnInit(): void {
    this.apiRestService.DestinazioniOther({id:this.idDestinazione}).subscribe(data=>{
      this.Other = data?.data;
    })
  }
  Sposta(){
    if(this.SelectedOther[0]?.id && this.send?.quantita > 0){
      this.send.voce = this.item.id;
      this.send.destinazione = this.SelectedOther[0].id;
      this.apiRestService.DestinazioniSposta(this.send).subscribe(()=>{
        this.closeModal();
      })
    }else
    this.toast.warning("inserire i campi richiesti");

  }
  closeModal(){
    this.activeModal.dismiss();
    this.Refresh.emit();
  }

}
